require('angular-ui-router/release/angular-ui-router.min.js')
require("angular-ui-router/release/stateEvents.min.js");
require("angular-ui-router.statehelper/statehelper.min.js");

module.exports = {
    uiRouter: 'ui.router',
    uiRouterStateEvents: 'ui.router.state.events',
    uiRouterStateHelper: 'ui.router.stateHelper'
}
